"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modal_dialog_1 = require("../modal-dialog");
const DefaultOkButtonText = "OK";
const DefaultCancelButtonText = "Cancel";
const OkCloseButton = "ok";
const CancelCloseButton = "cancel";
class InputDialog extends modal_dialog_1.default {
    // CAUTION  never ever try to store any dynamic state in an
    // InputDialog object since it is treated as immutable
    // Currently, solely ActiveModalDialog is known to be capable of
    // representing individual dialog instances.
    constructor(_inputDialogConfig = {}) {
        super(_inputDialogConfig); // call ModalDialog's constructor
        this._inputDialogConfig = _inputDialogConfig;
    }
    getCssClass() {
        return this._inputDialogConfig.cssClass || "input-modal-dialog";
    }
    get dirtyCssClass() {
        return this._inputDialogConfig.dirtyCssClass || "dirty";
    }
    get invalidCssClass() {
        return this._inputDialogConfig.invalidCssClass || "invalid";
    }
    get hasFooter() {
        return true;
    }
    get okButtonSelector() {
        const selector = this._inputDialogConfig.okButtonSelector || `.${this.okCloseButton}-button`;
        return `${this.footerSelector} ${selector}`;
    }
    get cancelButtonSelector() {
        const selector = this._inputDialogConfig.cancelButtonSelector || `.${this.cancelCloseButton}-button`;
        return `${this.footerSelector} ${selector}`;
    }
    get okButtonText() {
        return this._inputDialogConfig.okButtonText || DefaultOkButtonText;
    }
    get cancelButtonText() {
        return this._inputDialogConfig.cancelButtonText || DefaultCancelButtonText;
    }
    get okCloseButton() {
        return OkCloseButton;
    }
    get cancelCloseButton() {
        return CancelCloseButton;
    }
    getButtonMatcher() {
        return clickEvent => {
            if (this.jQuery(clickEvent.target).hasClass(`${this.okCloseButton}-button`)) {
                return this.okCloseButton;
            }
            if (this.jQuery(clickEvent.target).hasClass(`${this.cancelCloseButton}-button`)) {
                return this.cancelCloseButton;
            }
        };
    }
    handleButtonClick(buttonIdentifier, resultCallback) {
        this.hide();
        if (resultCallback) {
            if (buttonIdentifier === this.okCloseButton) {
                resultCallback(this.getInputValue() || ""); // || "" to avoid undefined
            }
            else {
                resultCallback(); // call result callback with undefined
            }
        }
    }
    handleDialogShown(shownEvent) {
        super.handleDialogShown(shownEvent);
        // focus the input field (= the input's caret is going to blink)
        this.focusInput();
    }
    toString() {
        return "Input Dialog";
    }
    setContentVisibility(visible) {
        // show my modal body
        this.setVisibilityBySelector(this.bodySelector, visible);
        // show my modal buttons
        this.jQuery(this.okButtonSelector).text(visible ? this.okButtonText : DefaultOkButtonText);
        this.jQuery(this.cancelButtonSelector).text(visible ? this.cancelButtonText : DefaultCancelButtonText);
        this.setVisibilityBySelector(this.okButtonSelector, visible);
        this.setVisibilityBySelector(this.cancelButtonSelector, visible);
        // reset my input value
        if (visible) {
            const value = this._inputDialogConfig.currentValue || "";
            this.setInputValue(value);
            this.selectInput();
        }
        else {
            this.clearInputValue();
        }
        // show my modal footer
        if (this.hasFooter) {
            this.setVisibilityBySelector(this.footerSelector, visible);
        }
    }
}
exports.default = InputDialog;
